import { useTranslation } from "#hooks";
import { Translations } from "#interfaces";
import { bp } from "#shared/theme";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { ChartContainer } from "../ChartContainer/ChartContainer";
import { ContractsChartMobile } from "../ContractsChartMobile/ContractsChartMobile";
import { InfoItemProps } from "../Info/Info";
import { MultipleChart } from "../MultipleChart/MultipleChart";

export const ContractsChart: React.FC = () => {
  const isDesktop = useMediaQuery({ query: bp.m });
  const { t } = useTranslation("tour");
  const labels = t("ContractsChart") as Translations;
  return (
    <ChartContainer
      title={labels.title}
      tooltipContent={labels.tooltip}
      list={(labels.info as unknown) as InfoItemProps[]}
    >
      {isDesktop ? <MultipleChart labels={labels} /> : <ContractsChartMobile labels={labels} />}
    </ChartContainer>
  );
};
